<h5 mat-dialog-title mat-dialog-draggable-title>
    <span *ngIf="!isNotAttestedUser">{{'kyc.refuse_identify_success_title' | translate}}</span>
    <span *ngIf="isNotAttestedUser">{{'kyc.refuse_verify_subject_success_title' | translate}}</span>
    <button type="button" class="close" aria-label="Close" cdkFocusInitial (click)="close()">
        <span aria-hidden="true">&times;</span>
    </button>
</h5>
<mat-divider style="padding-bottom: 1rem;"></mat-divider>
<form name="form" #f="ngForm" (ngSubmit)="f.form.valid" appFocusFirstElement>
    <mat-dialog-content>
        <div>
            <div [innerHTML]="messageString" style=" padding: 5px 7px 15px; font-size: medium; overflow-wrap: break-word;"></div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="center" class="pt-2 pb-3">
        <button mat-raised-button color="primary" type="button" (click)="close()" class="mr-2">
            <mat-icon class="mr-0">close</mat-icon>{{ "button.close" | translate }}
        </button>
    </mat-dialog-actions>
</form>